import React from "react";
import { useTranslate } from "../../../../components/TranslationText";
import { TranslationKeys } from "../../../../constants/TranslationKeys";
import EahsForm from "../../../../components/EahsForm";
import FormTextInput from "../../../../components/FormInputs/FormTextInput";
import { IBCFieldNames } from "../utils/InternationalBreedingCertificateConstants";
import { useWatch } from "react-hook-form";

const IBCCommentsSection = ({
    comment: propComment,
    isSentBack = false,
    isReadOnly = false
}) => {
    const { translate } = useTranslate();
    const watchedComment = useWatch({ name: IBCFieldNames.COMMENT });
    const watchedOwnerComment = useWatch({ name: IBCFieldNames.OWNER_COMMENT });
    const adminComment = propComment || watchedComment;
    const hasAdminComment = !!adminComment;
    const hasOwnerComment = !!watchedOwnerComment;

    const showOwnerComment = hasOwnerComment || isSentBack;
    const showSection = hasAdminComment || showOwnerComment;

    if (!showSection) return null;

    const colClass = (hasAdminComment && showOwnerComment)
        ? "col-md-6 col-sm-12 col-12 mb-form-group"
        : "col-md-12 col-sm-12 col-12 mb-form-group";

    return (
        <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate(TranslationKeys.COMMENT, "Comment")}>
            {hasAdminComment && (
                <div className={colClass}>
                    <FormTextInput
                        name={IBCFieldNames.COMMENT}
                        label={translate(TranslationKeys.EAHS_COMMENTS, "EAHS Comments")}
                        type="textarea"
                        rows={5}
                        style={{ height: '140px' }}
                        disabled={true}
                    />
                </div>
            )}

            {showOwnerComment && (
                <div className={colClass}>
                    <FormTextInput
                        name={IBCFieldNames.OWNER_COMMENT}
                        label={translate(TranslationKeys.OWNER_COMMENT, "Owner Comment")}
                        type="textarea"
                        rows={5}
                        style={{ height: '140px' }}
                        disabled={isReadOnly || !isSentBack}
                    />
                </div>
            )}
        </EahsForm>
    );
};

export default IBCCommentsSection;
